import { create } from 'zustand';

type AppStatusState = {
  toolAvailability: Record<string, boolean>;
};

type AppStatusActions = {
  patch: (p: Partial<AppStatusState>) => void;
};

const initialState: AppStatusState = {
  toolAvailability: {},
};

export const useAppStatusStore = create<AppStatusState & AppStatusActions>((set) => ({
  ...initialState,
  patch: (p) => set(p),
}));